import React from 'react';
import Carousel from "js/components-v2/pages/BuyerPage/Carousel";
import userCountry from 'js/services/UserCountry';
import CarouselNG from 'js/components-v2/pages/BuyerPage/CarouselNG';

const BuyerRefHowItWorks = () => {
  const counter = [
    { sn: '1.', icon: '/images/icons/online-shop.svg', text: 'Add items for sale to your store and get store link.' },
    { sn: '2.', icon: '/images/icons/social-media-1.svg', text: 'We\'ll automatically send the buyer the payment link for this transaction.' },
    { sn: '3.', icon: '/images/icons/truck-1.svg', text: 'Accept offer from buyer and ship item purchased.' },
    { sn: '4.', icon: '/images/icons/analytics.svg', text: 'Get paid fast. Max 24 hours after item is delivered to buyer.' }
  ];
  return (
    <div className="how-it-works">
      <div className="pod-container">
        <div className="d-flex justify-content-center tw-mt-[40px] tw-mb-4">
          <h1 className="title-text">How it works</h1>
        </div>
        <div className="d-flex justify-content-center tw-mb-[4rem]">
          <p className="tw-text-center tw-text-white">Your sales journey is just in 4 simple steps.</p>
        </div>
        <div className="tw-grid tw-grid-cols-1 tw-gap-8 !tw-divide-x-[0.5px] !tw-divide-gray-100 md:tw-grid-cols-4 md:tw-gap-4">
          {counter.map((item, index) => (
            <div key={index} className="tw-text-left tw-p-6 border-grey-[0.5px] rounded-lg tw-shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
            style={{borderRadius:'25px', border:'grey 0.2px solid'}}>
              <h6 className="tw-font-bold tw-text-white">{item.sn}</h6>
              <img alt={item.sn} src={item.icon} height="39.6px" width="40px" style={{borderRadius:'10px'}} />
              <p className="tw-mt-4 tw-font-light tw-text-white tw-font-[16px]">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuyerRefHowItWorks;
